import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c79bd42"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "arrow" }, null, -1))
const _hoisted_2 = ["value"]
const _hoisted_3 = { class: "station-selector" }
const _hoisted_4 = { class: "tab-selector" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["id", "checked"]
const _hoisted_7 = ["for"]
const _hoisted_8 = { class: "list-content" }
const _hoisted_9 = ["onClick"]

import { ref, computed, watch } from 'vue'

type UdcTabbedSelectProps = {
  title: string
  tabs: {
    title: string
    items: {
      title: string
      items: { title: string }[]
    }
  }[]
  defaults?: {
    tabIndex: number
    listItemIndex: number
    itemIndex: number
  }
}


export default /*#__PURE__*/_defineComponent({
  props: {
    title: null,
    tabs: null,
    defaults: null
  },
  emits: ['select'],
  setup(__props: any, { emit }) {

const props = __props as {
  title: string
  tabs: {
    title: string
    items: {
      title: string
      items: { title: string }[]
    }
  }[]
  defaults?: {
    tabIndex: number
    listItemIndex: number
    itemIndex: number
  }
}




const selected = ref<{
  tabIndex: number
  listItemIndex: number
  itemIndex: number
}>({
  tabIndex: props.defaults?.tabIndex || 0,
  listItemIndex: props.defaults?.listItemIndex || 0,
  itemIndex: props.defaults?.itemIndex || 0,
})

const selectedTabIndex = ref<number>(0)

const selectedItem = computed(() => {
  const { tabIndex, listItemIndex, itemIndex } = selected.value

  return props.tabs[tabIndex].items[listItemIndex].items[itemIndex]
})

const isOpen = ref(false)

const isSelectedTab = (tabIndex: number) => {
  return selectedTabIndex.value === tabIndex
}

const isSelectedListItem = (listItemIndex: number) => {
  return selected.value.listItemIndex === listItemIndex
}

const isSelectedItem = (listItemIndex: number, itemIndex: number) => {
  return (
    selected.value.tabIndex === selectedTabIndex.value &&
    selected.value.listItemIndex === listItemIndex &&
    selected.value.itemIndex === itemIndex
  )
}

const selectTab = (tabIndex: number) => {
  if (selectedTabIndex.value !== tabIndex) {
    selectedTabIndex.value = tabIndex
  }
}

const select = (listItemIndex: number, itemIndex: number) => {
  selected.value.tabIndex = selectedTabIndex.value
  selected.value.listItemIndex = listItemIndex
  selected.value.itemIndex = itemIndex
  toggleSelector()
  emit('select', selected.value)
}

const toggleSelector = () => {
  isOpen.value = !isOpen.value
}

watch(
  () => props.defaults,
  () => {
    selected.value.tabIndex = props.defaults?.tabIndex || 0
    selected.value.listItemIndex = props.defaults?.listItemIndex || 0
    selected.value.itemIndex = props.defaults?.itemIndex || 0
  }
)

return (_ctx: any,_cache: any) => {
  return (__props.tabs)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass([{ 'single-graph-selector': __props.tabs.length === 1, 'box-shadow': isOpen.value }, "graph-selector"])
      }, [
        _createElementVNode("li", {
          class: "selector-input",
          onClick: toggleSelector
        }, [
          _hoisted_1,
          _createElementVNode("input", {
            type: "text",
            value: _unref(selectedItem)?.title
          }, null, 8, _hoisted_2)
        ]),
        (isOpen.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["select-list", { open: isOpen.value }])
            }, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("p", null, _toDisplayString(__props.title), 1),
                _withDirectives(_createElementVNode("div", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tabs, (tab, i) => {
                    return (_openBlock(), _createElementBlock("div", {
                      onClick: ($event: any) => (selectTab(i)),
                      key: i,
                      class: _normalizeClass([isSelectedTab(i) && 'selected', "tab-selector-item"])
                    }, _toDisplayString(tab.title), 11, _hoisted_5))
                  }), 128))
                ], 512), [
                  [_vShow, __props.tabs.length > 1]
                ])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tabs[selectedTabIndex.value].items, (listItem, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "select-list-item",
                  key: i
                }, [
                  _createElementVNode("input", {
                    id: `toggle${i}`,
                    type: "checkbox",
                    class: "toggle",
                    checked: !listItem.title || isSelectedListItem(i)
                  }, null, 8, _hoisted_6),
                  _withDirectives(_createElementVNode("label", {
                    for: `toggle${i}`,
                    class: "toggle-switch"
                  }, _toDisplayString(listItem.title), 9, _hoisted_7), [
                    [_vShow, listItem.title]
                  ]),
                  _createElementVNode("ul", _hoisted_8, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listItem.items, (item, j) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: j,
                        class: _normalizeClass({ selected: isSelectedItem(i, j) }),
                        onClick: ($event: any) => (select(i, j))
                      }, _toDisplayString(item.title), 11, _hoisted_9))
                    }), 128))
                  ])
                ]))
              }), 128))
            ], 2))
          : _createCommentVNode("", true)
      ], 2))
    : _createCommentVNode("", true)
}
}

})